import { get } from 'api/fetch'

import { Pagination } from './types/types'

export type Drop = {
  id: number
  slug: string
  name: string
  email: string
  secretCode: number
  country: string
  city: string
  description: string
  dropURL: string
  privateDrop: boolean
  virtualDrop: boolean
  imageURL: string
  animationURL: string
  year: number
  startDate: string
  endDate: string
  fromAdmin: boolean
  dropTemplate: string
  fancyId: string
  createdDate: string
  dropTemplateId: number
}

export interface Resp {
  results: Drop[]
  meta: Pagination
}

export interface Params {
  [key: string]: string
}

const apiUrl = process.env.REACT_APP_API_V2 ?? ''

export const getDrops = async (params: Params): Promise<Resp> => {
  const res = await get(`${apiUrl}/drop`, params)

  if (res.status === 200 && res.parsedBody) {
    return res.parsedBody as Resp
  }

  throw new Error('There was an error retrieving the data')
}
